<template>
	<div class="wrap">
		<Title :title="vacationName"></Title>
		<div class="activity-form-wrap">
			<el-form :inline="true" class="activity-form">
				<el-form-item label="账号">
					<el-input v-model="userName" placeholder="请输入账号" clearable></el-input>
				</el-form-item>
				<el-form-item label="志愿者">
					<el-input v-model="nickName" placeholder="请输入活动报名姓名" clearable></el-input>
				</el-form-item>
				<el-form-item label="签收类型">
					<el-select v-model="signType" @change="setSelectedAudit">
						<el-option label="受助者签收" value="1"></el-option>
						<el-option label="志愿者签收" value="0"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button icon="el-icon-search" size="mini" type="primary" @click="toSearch">搜索</el-button>
					<el-button icon="el-icon-refresh" size="mini" @click="toReset">重置</el-button>
				</el-form-item>
			</el-form>
		</div>
		<div class="export-wrap">
			<el-button size="mini" type="primary" @click="getDownResult(1)">导出志愿者签收记录</el-button>
			<el-button  size="mini" type="primary" @click="getDownResult(2)">导出受助者签收记录</el-button>
		</div>
		<el-table border size="mini" :data="dataList" style="width: 100%">
			<el-table-column prop="userName" label="账号" height="30">
			</el-table-column>
			<el-table-column prop="nickName" label="志愿者" width="70">
			</el-table-column>
			<el-table-column prop="childrenName" label="接受人"  width="70">
			</el-table-column>
			<el-table-column prop="schoolName" label="学校信息">
			</el-table-column>
			<el-table-column prop="age" label="年龄" width="50">
			</el-table-column>
			<el-table-column label="性别" width="50">
				<template slot-scope="scope">
					<span v-if="scope.row.sex=='1'">男</span>
					<span v-else>女</span>
				</template>
			</el-table-column>
			<el-table-column label="通信地址/前往地点">
				<template slot-scope="scope">
					<span>{{scope.row.provinceName}} {{scope.row.cityName}} {{scope.row.districtName}} {{scope.row.address}}</span>
				</template>
			</el-table-column>
			<el-table-column prop="guardianName" label="签收人" width="70">
			</el-table-column>
			<el-table-column prop="guardianRelation" label="关系" width="50">
			</el-table-column>
			<el-table-column prop="phone" label="手机号">
			</el-table-column>
			<el-table-column label="签收时间">
				<template slot-scope="scope">
					{{scope.row.addTime|datefmt2('YYYY-MM-DD HH:mm')}}
				</template>
			</el-table-column>
			<el-table-column prop="packNum" label="礼包(个)"  width="70">
			</el-table-column>
			<el-table-column prop="packPrice" label="单价(元)" width="70">
			</el-table-column>
		</el-table>
		<Pagination :total="total" :pageSize="pageSize" @pageChange="handleCurrentChange"/>
	</div>
</template>

<script>
	import Title from '@/components/titleAdmin'
	import Pagination from '@/components/admin/pagination'
	import qs from 'qs'
	import { post, config, ajaxParam } from '@/units/request.js'
	export default {
		name: 'Signature',
		components: {
			Title,
			Pagination
		},
		data() {
			return {
				pageNum: 1,
				pageSize: 10,
				total: 0,
				dataList: [],
				vacationId: '',
				vacationName: '',
				signType: '1',  //0志愿者签收  1受助者签收
				userName: '', //账号
				nickName: '', //名称
				zyzIds: '', //选中的ids 如果有勾选
			}
		},
		created(){
			this.vacationId = this.$route.query.id||''
			this.getDataList()
		},
		methods: {
			//获取签收列表
			async getDataList() {
				let param = {
					vacationId: this.vacationId,
					signType: this.signType,
					userName: this.userName,
					nickName: this.nickName,
					pageNum: this.pageNum,
					pageSize: this.pageSize
				}
				ajaxParam(param)
				const res = await post('admin/signature/list', qs.stringify(param))
				if (res.data.code == 200) {
					this.dataList = res.data.page.items
					this.total = res.data.page.count
					this.vacationName = res.data.vacationName
					this.vacationId = res.data.vacationId
				}
			},
			//分页
			handleCurrentChange(e){
				this.voteList = []
				this.pageNum = e.number
				this.getDataList()
			},
			toSearch(){
				this.pageNum = 1
				this.total = 0
				this.getDataList()
			},
			toReset(){
				this.userName = ''
				this.nickName = ''
				this.signType = '1'
				this.pageNum = 1
				this.dataList = []
				this.getDataList()
			},
			setSelectedAudit(e){
				this.signType = e
				this.pageNum = 1
				this.dataList = []
				this.getDataList()
			},
			//导出志愿者签收记录
			getDownResult(type) {
				let url = ''
				let title = ''
				if(type == 1) {
					//志愿者
					url = 'admin/signature/downloadZyzResult?userName='+ this.userName+'&nickName=' + this.nickName+'&signType=' + this.signType+'&vacationId=' + this.vacationId
					title = '确定导出志愿者的签收记录吗？'
				} else if(type==2) {
					//受助者
					url = 'admin/signature/downloadSzzResult?userName='+ this.userName+'&nickName=' + this.nickName+'&signType=' + this.signType+'&vacationId=' + this.vacationId
					title = '确定导出受助者的签收记录吗？'
				}
				this.$confirm(title,'温馨提示',{
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(async () => {
					let downUrl = config.baseUrl + url
					window.location.href = downUrl
				}).catch(() => {

				})
			},
		}
	}
</script>

<style scoped lang="less">
	.wrap {
		background: #fff;
		border: 1px solid #e4e4e4;
		border-radius: 4px;
		margin-bottom: 10px;
		padding: 10px;
	}
	.export-wrap{
		display: flex;
		justify-content: flex-end;
		padding: 10px 0 15px;
	}
	/deep/ .el-form-item {
		margin-bottom: 0;
	}
	/deep/ .activity-form-wrap .el-input__inner {
		width: 160px;
		height: 30px;
		line-height: 30px;
		font-size: 12px!important;
	}

	/deep/ .el-button--primary {
		background: #EB6B1B;
		border-color: #EB6B1B;
	}

	/deep/ .el-button--mini,
	.el-button--mini.is-round {
		padding: 4px 8px;
	}

	/deep/ .el-button {
		font-size: 12px !important;
	}
</style>
